import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
import { Col, Container, Row, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { basicFormValidationHandler, formattedPrice } from "../utils";
// import { fetchCartFinish, fetchGetItemsFromCart } from "../actions/global";
import { isEmpty, isUndefined } from "lodash";

import ReCAPTCHA from "react-google-recaptcha";

import CheckoutProductItem from "../components/CheckoutProductItem";
import HeroText from "../components/HeroText";
import InputField from "../components/Reusable/InputField";
import PaymentOptions from "../components/PaymentOptions";
import i18next from "i18next";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchCartFinish, fetchCartItems } from "../actions/global";
import CartModalItem from "../components/Reusable/CartModalItem";

const Checkout = () => {
  const { t } = useTranslation();
  const heroData = {
    title: "Plaćanje",
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const recaptchaRef = useRef();

  const { dataCartInfo, dataCartItemsInfo, dataCartItems } = useSelector(
    (state) => state.globalReducer
  );

  const shippingTypes = [
    { value: "AKS", label: "AKS" },
    // { value: "D_EXPRESS", label: "D Express" },
    { value: "BEX", label: "BEX" },
  ];

  // const key = "6LeUftEoAAAAAGV2wD_uDEKaIrwHMZFw7sKDgkC9"; //localhost
  const key = "6LecVckqAAAAAKFAioAc4EYvDSsq3qK7woayVauH"; //up-it.shop.rs

  // useEffect(() => {
  //   if (dataCartItems && !dataCartItems?.amount) {
  //     navigate("/");
  //   }
  // }, [dataCartItems, navigate]);

  useEffect(() => {
    getToken();
  }, []);

  const getToken = async () => {
    if (recaptchaRef?.current) {
      const token = await recaptchaRef?.current.executeAsync();
      setData((prevData) => ({ ...prevData, token: token }));
    }
  };

  useEffect(() => {
    dispatch(fetchCartItems());
  }, [dispatch]);

  const initialState = {
    //fizicko lice
    firstName: "",
    lastName: "",

    //pravno lice
    pib: "",
    identificationNumber: "",
    company: "",

    //ostalo
    receiptNumber: "",
    email: "",
    address: "",
    postalCode: "",
    city: "",
    phone: "",
    note: "",
    shippingAddress: "",
    firm: false,
    code: "",

    shippingType: "AKS",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);

  const handleInputChange = (event) => {
    const { name, value, checked, type } = event?.target || {};

    setData((prevUser) => ({
      ...prevUser,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleInputChangePaymentMethod = (value) => {
    setData((prevUser) => ({
      ...prevUser,
      payment_method: value,
    }));
  };

  const clientValidationHandler = () => {
    let errorsObject = {};

    if (data.firm) {
      // PRAVNO LICE
      errorsObject = basicFormValidationHandler(
        {
          pib: data.pib,
          identificationNumber: data.identificationNumber,
          company: data.company,
          email: data.email,
          address: data.address,
          postalCode: data.postalCode,
          city: data.city,
          phone: data.phone,
        },
        t
      );
    } else {
      // FIZIČKO LICE
      errorsObject = basicFormValidationHandler(
        {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          address: data.address,
          postalCode: data.postalCode,
          city: data.city,
          phone: data.phone,
        },
        t
      );
    }

    setErrors(errorsObject);

    if (!isEmpty(errorsObject)) {
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    }

    return !isEmpty(errorsObject);
  };

  const handleCheckout = async (event) => {
    event.preventDefault();

    if (!isTermsAccepted) {
      toast.error("Morate prihvatiti uslove i odredbe pre nastavka", {
        theme: "colored",
      });
      return;
    }

    if (clientValidationHandler()) {
      return;
    }

    // console.log(data, "data");

    dispatch(fetchCartFinish(data, navigate, resetCaptcha));
  };

  const resetCaptcha = async () => {
    if (recaptchaRef?.current) {
      recaptchaRef.current.reset();

      // Ponovo generiši token (za invisible captcha)
      const newToken = await recaptchaRef.current.executeAsync();
      setData((prevData) => ({ ...prevData, token: newToken }));
    }
  };

  const handleTermsChange = (event) => {
    setIsTermsAccepted(event.target.checked);
  };

  return (
    <div className="checkout-holder-content">
      <div className="container">
        <div className="checkout-hero-holder">
          <HeroText data={heroData} />
        </div>

        <div className="checkout-content-main">
          <div className="checkout-content-form-holder">
            <Paper elevation={1}>
              <Container fluid>
                <div className="checkout-content-form">
                  <div className="checkout-title-info">
                    <h5>Kontakt podaci</h5>
                  </div>
                  <div className="checkout-content-form-inputs">
                    <Row>
                      <Col md={12}>
                        <Form.Group className="mb-3" controlId="email">
                          <Form.Label>
                            Email <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            type="email"
                            name="email"
                            value={data.email}
                            onChange={handleInputChange}
                            required
                            placeholder="Unesite email"
                            isInvalid={!!errors.postalCode}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.firstName || "Ovo polje je obavezno"}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      {/* <Col lg={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="firm"
                              checked={data?.firm}
                              onChange={handleInputChange}
                            />
                          }
                          label={"Pravno lice"}
                        />
                      </Col> */}
                    </Row>
                  </div>
                  <div className="checkout-title-info-section">
                    <h5>Detalji za naplatu</h5>
                  </div>
                  <div className="checkout-content-form-inputs">
                    <Row>
                      {data?.firm ? (
                        <Fragment>
                          <Col md={6}>
                            <Form.Group className="mb-3" controlId="pib">
                              <Form.Label>
                                PIB <span style={{ color: "red" }}>*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="pib"
                                value={data.pib}
                                onChange={handleInputChange}
                                required
                                placeholder="Unesite pib"
                                isInvalid={!!errors.pib}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.pib || "Ovo polje je obavezno"}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group
                              className="mb-3"
                              controlId="identificationNumber"
                            >
                              <Form.Label>
                                Matični broj{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="identificationNumber"
                                value={data.identificationNumber}
                                onChange={handleInputChange}
                                required
                                placeholder="Unesite matični broj"
                                isInvalid={!!errors.identificationNumber}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.identificationNumber ||
                                  "Ovo polje je obavezno"}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group className="mb-3" controlId="company">
                              <Form.Label>
                                Kompanija{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="company"
                                value={data.company}
                                onChange={handleInputChange}
                                required
                                placeholder="Unesite kompaniju"
                                isInvalid={!!errors.company}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.company || "Ovo polje je obavezno"}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <Col md={6}>
                            <Form.Group className="mb-3" controlId="firstName">
                              <Form.Label>
                                Ime <span style={{ color: "red" }}>*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="firstName"
                                value={data.firstName}
                                onChange={handleInputChange}
                                required
                                placeholder="Unesite ime"
                                isInvalid={!!errors.firstName}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.firstName || "Ovo polje je obavezno"}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col md={6}>
                            <Form.Group className="mb-3" controlId="lastName">
                              <Form.Label>
                                Prezime <span style={{ color: "red" }}>*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="lastName"
                                value={data.lastName}
                                onChange={handleInputChange}
                                required
                                placeholder="Unesite prezime"
                                isInvalid={!!errors.lastName}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.lastName || "Ovo polje je obavezno"}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Fragment>
                      )}

                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="address">
                          <Form.Label>
                            Adresa <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="address"
                            value={data.address}
                            onChange={handleInputChange}
                            required
                            isInvalid={!!errors.address}
                            placeholder="Unesite adresu"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.address || "Ovo polje je obavezno"}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group
                          className="mb-3"
                          controlId="shippingAddress"
                        >
                          <Form.Label>Adresa za dostavu (opciono)</Form.Label>
                          <Form.Control
                            type="text"
                            name="shippingAddress"
                            value={data.shippingAddress}
                            onChange={handleInputChange}
                            placeholder="Unesite adresu za dostavu"
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="postalCode">
                          <Form.Label>
                            Poštanski broj{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="postalCode"
                            value={data.postalCode}
                            onChange={handleInputChange}
                            required
                            placeholder="Unesite poštanski broj"
                            isInvalid={!!errors.postalCode}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.postalCode || "Ovo polje je obavezno"}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="city">
                          <Form.Label>
                            Grad <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="city"
                            value={data.city}
                            onChange={handleInputChange}
                            required
                            placeholder="Unesite grad"
                            isInvalid={!!errors.city}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.city || "Ovo polje je obavezno"}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group className="mb-3" controlId="phone">
                          <Form.Label>
                            Telefon <span style={{ color: "red" }}>*</span>
                          </Form.Label>
                          <Form.Control
                            type="tel"
                            name="phone"
                            value={data.phone}
                            onChange={handleInputChange}
                            required
                            placeholder="Unesite telefon"
                            isInvalid={!!errors.phone}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.phone || "Ovo polje je obavezno"}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={12}>
                        <Form.Group className="mb-3" controlId="note">
                          <Form.Label>Napomena</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            name="note"
                            value={data.note}
                            onChange={handleInputChange}
                            placeholder="Unesite napomenu"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <div className="checkout-title-info-section">
                    <h5>Dostava</h5>
                  </div>
                  <div className="checkout-payment-holder">
                    <RadioGroup
                      name="shippingType"
                      value={data.shippingType}
                      onChange={handleInputChange}
                    >
                      {shippingTypes.map((type) => (
                        <FormControlLabel
                          key={type.value}
                          value={type.value}
                          control={<Radio />}
                          label={type.label}
                        />
                      ))}
                    </RadioGroup>
                  </div>
                  <div className="checkout-title-info-section">
                    <h5>Plaćanje</h5>
                  </div>
                  <div className="checkout-payment-holder">
                    <PaymentOptions
                      t={t}
                      handleInputChangePaymentMethod={
                        handleInputChangePaymentMethod
                      }
                    />
                  </div>
                </div>
                <Row>
                  <Col md={12}>
                    <div className="checkout-button-holder">
                      <div className="checout-button-info-policy">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isTermsAccepted}
                              onChange={handleTermsChange}
                              required
                            />
                          }
                          label={
                            <Fragment>
                              Pročitao/la sam i prihvatam
                              <Link
                                to="/privacy-policy"
                                style={{
                                  textDecoration: "none",
                                  color: "#1976d2",
                                }}
                              >
                                {" "}
                                politiku privatnosti
                              </Link>{" "}
                            </Fragment>
                          }
                        />
                      </div>

                      <ReCAPTCHA
                        sitekey={key}
                        size="invisible"
                        ref={recaptchaRef}
                      />
                      <button
                        className="button-custom-black w-100"
                        onClick={handleCheckout}
                      >
                        Nastavite na plaćanje
                      </button>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Paper>
          </div>
          <div className="checkout-content-information-items">
            <Paper elevation={1}>
              <div className="checkout-content-main-holder">
                <h3>Pregled</h3>
                <div className="checkout-information-summary">
                  <div className="checkout-information-summary-total">
                    <div className="checkout-information-summary-item-title">
                      Ukupno
                    </div>
                    <div className="checkout-information-summary-item-sum">
                      {formattedPrice(
                        dataCartItems?.amount + dataCartItems?.shipping
                      )}{" "}
                      <small>RSD</small>
                    </div>
                  </div>
                </div>
                <div className="checkout-information-list-items">
                  {dataCartItems?.items?.map((item, key) => (
                    <CheckoutProductItem item={item} key={key} />
                  ))}
                </div>
              </div>
            </Paper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
